import { type FC, type PropsWithChildren, useEffect } from 'react';
import posthog from 'posthog-js';

import { ENV } from '@/common/app/env';
import { useAppClose } from '@/common/hooks/app-close';
import { usePlaydeckListener } from '@/common/hooks/playdeck-listener';
import { useTelegramInit } from '@/common/hooks/telegram-init';
import { Playdeck } from '@/common/lib/playdeck';

const UserInit: FC<PropsWithChildren> = ({ children }) => {
  useTelegramInit();
  usePlaydeckListener();
  useAppClose();

  useEffect(() => {
    if (!ENV.IS_DEV) {
      const loadTimeMs = Math.round(performance.now());
      const loadTimeSeconds = +(loadTimeMs / 1000).toFixed(2);

      Playdeck.sendAnalitics({
        type: 'custom_event',
        name: 'game_load_finished',
        user_properties: {},
        event_properties: {
          time_ms: loadTimeMs,
          time_seconds: loadTimeSeconds,
        },
      });
      posthog.capture('game_load_finished', {
        load_time_ms: loadTimeMs,
        load_time_seconds: loadTimeSeconds,
      });
    }
    Playdeck.postMessage({ method: 'loading', value: 100 }, '*');
    Playdeck.getPlaydeckState();
    console.timeEnd('loading-timer');
  }, []);

  return children;
};

export { UserInit };
